// Function to fetch product data by handle
window.fetchProductData = function (
  handle,
  cardWrapper,
  badgeValue,
  productId,
  variantId,
  label
) {
  const url = `/products/${handle}.js`;

  fetch(url)
    .then((response) => {
      if (!response.ok) {
        console.error("Error fetching product:", response.status);
        throw new Error("Product not found");
      }
      return response.json();
    })
    .then((productData) => {
      let images = productData.images;
      let comparePrice = productData.variants[0].compare_at_price;
      let price = productData.variants[0].price;
      let title = productData.title;
      let productUrl = `/products/${handle}`;
      let variants = productData.variants;

      // Update carousel images
      const carouselTrack = cardWrapper.querySelector(
        ".card__media-carousel-track"
      );
      if (carouselTrack) {
        carouselTrack.innerHTML = "";
        images.slice(0, 4).forEach((image, index) => {
          const slide = document.createElement("div");
          slide.className = `card__media-slide${index === 0 ? " active" : ""}`;
          slide.setAttribute("data-index", index);
          slide.innerHTML = `
            <a href="${productUrl}" class="media media--transparent media--hover-effect">
              <img
                srcset="${image} 165w, ${image} 360w, ${image} 533w, ${image} 720w"
                src="${image}"
                sizes="(min-width: ${window.settings?.page_width || 1440}px) ${
            window.settings?.page_width - 130 || 1310
          }/4 }}px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
                alt="${title}"
                class="motion-reduce"
                ${index !== 0 ? 'loading="lazy"' : ""}
                width="533"
                height="533"
              >
            </a>
          `;
          carouselTrack.appendChild(slide);
        });

        // Reinitialize carousel
        const carousel = carouselTrack.closest(".card__media-carousel");
        if (carousel) {
          carousel.classList.remove("initialized");
          new ProductCardCarousel(carousel);
        }
      }

      const variantList = cardWrapper.querySelector("#variant-list");
      if (variantList) {
        variantList.innerHTML = "";
        // Iterate over each variant and create a list item
        productData.variants.forEach((variant) => {
          const listItem = document.createElement("li");
          listItem.innerHTML = `
            <input type="radio" 
                   data-variant-id="${variant.id}" 
                   class="visually-hidden">
            <label class="add-to-cart-button${
              variant.available ? "" : " unavailable"
            }" 
                   data-variant-id="${variant.id}">
                ${variant.title}
            </label>
          `;
          variantList.appendChild(listItem);
        });
      }

      // Update quick add modals
      const quickAddModal = cardWrapper.querySelector("quick-add-modal");
      const quickAddButton = cardWrapper.querySelector(".quick-add__submit");

      // Handle standard quick add modal
      if (quickAddModal && quickAddButton) {
        quickAddButton.setAttribute("data-product-url", productUrl);
        if (quickAddModal.hasAttribute("open")) {
          quickAddModal.hide();
          setTimeout(() => {
            quickAddModal.show(quickAddButton);
          }, 100);
        }
      }

      // Handle bulk quick add modal
      // First try to find single variant bulk quick add
      const bulkQuickAdd = cardWrapper.querySelector("quick-add-bulk");

      // Then try to find multiple variant bulk quick add
      const bulkQuickAddModal = cardWrapper.querySelector(
        ".quick-add.no-js-hidden"
      );

      if (bulkQuickAdd) {
        // Update bulk quick add attributes
        bulkQuickAdd.setAttribute("data-id", variantId);
        bulkQuickAdd.setAttribute(
          "data-min",
          productData.variants[0].quantity_rule?.min || 1
        );
        bulkQuickAdd.setAttribute("data-index", variantId);
        bulkQuickAdd.setAttribute("data-product-url", productUrl);

        // Reset all quantity inputs first
        const allQuantityInputs = bulkQuickAdd.querySelectorAll(
          'input[type="number"]'
        );
        allQuantityInputs.forEach((input) => {
          input.value = "0";
          input.setAttribute("value", "0");
          input.setAttribute("data-cart-quantity", "0");
        });

        // Reset all total prices
        const allTotalPrices = bulkQuickAdd.querySelectorAll(
          ".variant-item__totals .price"
        );
        allTotalPrices.forEach((price) => {
          price.textContent = "$0.00";
        });

        // Update the form if it exists
        const form = bulkQuickAdd.querySelector('form[action^="/cart/add"]');
        if (form) {
          form.action = "/cart/add";

          // Update or create the variant ID input
          let variantInput = form.querySelector('input[name="id"]');
          if (!variantInput) {
            variantInput = document.createElement("input");
            variantInput.type = "hidden";
            variantInput.name = "id";
            form.appendChild(variantInput);
          }
          variantInput.value = variantId;

          // Clear any existing error messages
          const errorMessages = form.querySelectorAll(
            ".quick-order-list-error"
          );
          errorMessages.forEach((error) => {
            error.textContent = "";
            error.style.display = "none";
          });
        }

        // Update the quantity input if it exists
        const quantityInput = bulkQuickAdd.querySelector("quantity-input");
        if (quantityInput) {
          quantityInput.setAttribute("data-variant-id", variantId);
          quantityInput.id = `Quantity-Input-${variantId}`;

          // Update quantity buttons
          const minusButton = quantityInput.querySelector(
            'button[name="minus"]'
          );
          const plusButton = quantityInput.querySelector('button[name="plus"]');

          if (minusButton) {
            minusButton.setAttribute(
              "aria-label",
              `Decrease quantity for ${title}`
            );
          }
          if (plusButton) {
            plusButton.setAttribute(
              "aria-label",
              `Increase quantity for ${title}`
            );
          }

          const input = quantityInput.querySelector('input[type="number"]');
          if (input) {
            input.id = `Quantity-${variantId}`;
            input.setAttribute("data-variant-id", variantId);
            input.setAttribute("data-quantity-variant-id", variantId);
            input.setAttribute("data-index", variantId);
            input.setAttribute("name", "updates[]");
            input.setAttribute("min", "0");
            input.setAttribute("data-min", "1");
            input.setAttribute("value", "0");
            input.setAttribute("data-cart-quantity", "0");
            input.setAttribute(
              "min",
              productData.variants[0].quantity_rule?.min || 1
            );
            input.setAttribute(
              "max",
              productData.variants[0].quantity_rule?.max || ""
            );
            input.setAttribute(
              "step",
              productData.variants[0].quantity_rule?.increment || 1
            );
          }

          // Update error message container if it exists
          const errorContainer = quantityInput
            .closest(".variant-item")
            ?.querySelector(".variant-item__error");
          if (errorContainer) {
            errorContainer.id = `Quick-order-list-item-error-mobile-${variantId}`;
            const errorText = errorContainer.querySelector(
              ".variant-item__error-text"
            );
            if (errorText) {
              errorText.id = `Quick-order-list-item-error-text-${variantId}`;
              errorText.textContent = "";
            }
          }
        }

        // Force quick add bulk to reinitialize
        bulkQuickAdd.removeAttribute("initialized");
        if (
          typeof customElements.get("quick-add-bulk")?.prototype
            ?.connectedCallback === "function"
        ) {
          bulkQuickAdd.connectedCallback();
        }
      } else if (bulkQuickAddModal) {
        // Update the modal opener
        const modalOpener = bulkQuickAddModal.querySelector("modal-opener");

        if (modalOpener) {
          // Extract section ID from the modal opener's ID
          const modalOpenerId = modalOpener.id;

          // The ID format is "QuickBulk-{productId}-{sectionId}"
          // Extract everything after the second dash as the section ID
          const firstDashIndex = modalOpenerId.indexOf("-");
          const secondDashIndex = modalOpenerId.indexOf(
            "-",
            firstDashIndex + 1
          );
          const currentProductId = modalOpenerId.substring(
            firstDashIndex + 1,
            secondDashIndex
          );
          const sectionId = modalOpenerId.substring(secondDashIndex + 1);

          // Find the modal dialog in the document
          const modalId = `QuickAddBulk-${currentProductId}-${sectionId}`;
          const modalDialog = document.querySelector(`#${modalId}`);

          // Update the modal opener
          modalOpener.setAttribute("data-modal", `#${modalId}`);

          // Update the button inside modal opener
          const button = modalOpener.querySelector("button");
          if (button) {
            button.setAttribute("data-product-url", productUrl);
            button.setAttribute(
              "aria-labelledby",
              `quick-add-${sectionId}-${currentProductId}-submit title-${sectionId}-${currentProductId}`
            );
          }

          if (modalDialog) {
            // Always hide and show the modal to force a refresh
            if (modalDialog.hasAttribute("open")) {
              modalDialog.hide();
            }

            // Update the button's URL before showing the modal again
            const modalButton = modalOpener.querySelector("button");
            if (modalButton) {
              modalButton.setAttribute("data-product-url", productUrl);
            }

            // Update the modal content directly
            const modalContent = modalDialog.querySelector(
              ".quick-add-modal__content"
            );
            if (modalContent) {
              // Clear any existing error messages
              const errorMessages = modalContent.querySelectorAll(
                ".variant-item__error"
              );
              errorMessages.forEach((error) => {
                error.style.display = "none";
                const errorText = error.querySelector(
                  ".variant-item__error-text"
                );
                if (errorText) {
                  errorText.textContent = "";
                }
              });

              // Update product title
              const titleElements =
                modalContent.querySelectorAll("h2, h3, .h2");
              titleElements.forEach((titleElement) => {
                if (titleElement) {
                  titleElement.textContent = title;
                }
              });

              // Update variant names and SKUs
              const variantRows =
                modalContent.querySelectorAll(".variant-item");
              if (variantRows.length > 0) {
                // Reset all quantities first
                variantRows.forEach((row) => {
                  const quantityInput = row.querySelector(
                    'input[type="number"]'
                  );
                  if (quantityInput) {
                    quantityInput.value = "0";
                    quantityInput.setAttribute("value", "0");
                    quantityInput.setAttribute("data-cart-quantity", "0");
                  }
                  // Reset total price
                  const totalPrice = row.querySelector(
                    ".variant-item__totals .price"
                  );
                  if (totalPrice) {
                    totalPrice.textContent = "$0.00";
                  }
                });

                variants.forEach((variant) => {
                  // Find the variant row by matching the variant name
                  const variantRow = Array.from(variantRows).find((row) => {
                    const nameElement = row.querySelector(
                      ".variant-item__name"
                    );
                    return (
                      nameElement &&
                      nameElement.textContent.trim() === variant.title
                    );
                  });

                  if (variantRow) {
                    // Update variant row ID and data attributes
                    variantRow.id = `Variant-${variant.id}`;
                    variantRow.setAttribute("data-variant-id", variant.id);

                    // Update SKU if it exists
                    const skuElements =
                      variantRow.querySelectorAll(".variant-item__sku");
                    skuElements.forEach((skuElement) => {
                      if (skuElement) {
                        skuElement.textContent = variant.sku;
                      }
                    });

                    // Update quantity input
                    const quantityInput =
                      variantRow.querySelector("quantity-input");
                    if (quantityInput) {
                      // Update quantity input attributes
                      quantityInput.setAttribute("data-variant-id", variant.id);
                      quantityInput.setAttribute(
                        "class",
                        "quantity cart-quantity"
                      );
                      quantityInput.id = `Quantity-Input-${variant.id}`;

                      // Update quantity buttons
                      const minusButton = quantityInput.querySelector(
                        'button[name="minus"]'
                      );
                      const plusButton = quantityInput.querySelector(
                        'button[name="plus"]'
                      );

                      if (minusButton) {
                        minusButton.setAttribute(
                          "aria-label",
                          `Decrease quantity for ${variant.title}`
                        );
                      }
                      if (plusButton) {
                        plusButton.setAttribute(
                          "aria-label",
                          `Increase quantity for ${variant.title}`
                        );
                      }

                      // Update the number input inside quantity-input
                      const numberInput = quantityInput.querySelector(
                        'input[type="number"]'
                      );
                      if (numberInput) {
                        numberInput.id = `Quantity-${variant.id}`;
                        numberInput.setAttribute(
                          "data-quantity-variant-id",
                          variant.id
                        );
                        numberInput.setAttribute("data-variant-id", variant.id);
                        numberInput.setAttribute("data-index", variant.id);
                        numberInput.setAttribute("name", "updates[]");
                        numberInput.setAttribute("min", "0");
                        numberInput.setAttribute("data-min", "1");
                        numberInput.setAttribute("value", "0");
                        numberInput.setAttribute("data-cart-quantity", "0");
                        numberInput.setAttribute(
                          "aria-label",
                          `Quantity for ${variant.title}`
                        );
                      }

                      // Update error message container ID if it exists
                      const errorContainer = variantRow.querySelector(
                        ".variant-item__error"
                      );
                      if (errorContainer) {
                        errorContainer.id = `Quick-order-list-item-error-mobile-${variant.id}`;
                        const errorText = errorContainer.querySelector(
                          ".variant-item__error-text"
                        );
                        if (errorText) {
                          errorText.id = `Quick-order-list-item-error-text-${variant.id}`;
                        }
                      }

                      // Update progress bar if it exists
                      const progressBar = quantityInput.querySelector(
                        ".progress-bar-container"
                      );
                      if (progressBar) {
                        progressBar.id = `Progress-${variant.id}`;
                      }

                      // Update quantity popover if it exists
                      const quantityPopover =
                        variantRow.querySelector("quantity-popover");
                      if (quantityPopover) {
                        quantityPopover.setAttribute(
                          "data-variant-id",
                          variant.id
                        );
                        const popoverWrapper = quantityPopover.querySelector(
                          ".quantity-popover-wrapper"
                        );
                        if (popoverWrapper) {
                          popoverWrapper.id = `Quantity-popover-${variant.id}`;
                        }
                      }
                    }

                    // Update price display
                    const priceElements = variantRow.querySelectorAll(".price");
                    priceElements.forEach((priceElement) => {
                      if (priceElement) {
                        if (priceElement.closest(".variant-item__totals")) {
                          priceElement.textContent = "$0.00";
                        } else {
                          priceElement.textContent = `$${(
                            variant.price / 100
                          ).toFixed(2)}/ea`;
                        }
                      }
                    });
                  }
                });
              }

              // Update the product image if it exists
              const mediaContainer = modalContent.querySelector(
                ".quick-add__product-media"
              );
              if (mediaContainer && images.length > 0) {
                mediaContainer.innerHTML = `
                  <div class="quick-add__product-container global-media-settings">
                    <img
                      srcset="${images[0]} 165w, ${images[0]} 360w, ${images[0]} 533w, ${images[0]} 720w"
                      src="${images[0]}"
                      alt="${title}"
                      loading="lazy"
                      width="533"
                      height="533"
                    >
                  </div>
                `;
              }

              // Update prices
              const priceElements = modalContent.querySelectorAll(
                ".price__regular .money"
              );
              priceElements.forEach((priceElement) => {
                if (priceElement) {
                  priceElement.textContent = `$${(price / 100).toFixed(2)}`;
                }
              });

              const compareAtPriceElements = modalContent.querySelectorAll(
                ".price__compare-at .money"
              );
              compareAtPriceElements.forEach((compareAtPrice) => {
                if (compareAtPrice) {
                  const container =
                    compareAtPrice.closest(".price__compare-at");
                  if (container) {
                    if (comparePrice) {
                      compareAtPrice.textContent = `$${(
                        comparePrice / 100
                      ).toFixed(2)}`;
                      container.style.display = "block";
                    } else {
                      container.style.display = "none";
                    }
                  }
                }
              });

              // Update product links
              const links = modalContent.querySelectorAll(
                "a[href*='/products/']"
              );
              links.forEach((link) => {
                if (link) link.href = productUrl;
              });

              // Update bulk modal element
              const bulkModalElement = modalContent.querySelector("bulk-modal");
              if (bulkModalElement) {
                // Reset the form state
                let cartForm = modalContent.querySelector(
                  'form[action^="/cart/add"]'
                );
                if (cartForm) {
                  cartForm.reset();
                  // Clear any form-level error messages
                  const formErrors =
                    cartForm.querySelectorAll(".form__message");
                  formErrors.forEach((error) => {
                    error.style.display = "none";
                    error.textContent = "";
                  });

                  // Clear quick-order-list error messages
                  const quickOrderListErrors = modalContent.querySelectorAll(
                    ".quick-order-list-error"
                  );
                  quickOrderListErrors.forEach((error) => {
                    error.textContent = "";
                    error.style.display = "none";
                  });

                  // Clear any error states on the form
                  cartForm.classList.remove("has-error");
                  const errorTemplate = modalContent.querySelector(
                    "#QuickOrderListErrorTemplate-" + currentProductId
                  );
                  if (errorTemplate) {
                    errorTemplate.style.display = "none";
                  }
                }

                bulkModalElement.setAttribute("data-url", productUrl);
                bulkModalElement.setAttribute(
                  "data-product-id",
                  currentProductId
                );
                bulkModalElement.setAttribute("data-section-id", sectionId);
                bulkModalElement.setAttribute("data-variant-id", variantId);

                // Update the form action and variant ID
                cartForm = modalContent.querySelector(
                  'form[action^="/cart/add"]'
                );
                if (cartForm) {
                  cartForm.action = "/cart/add";

                  // Update or create the variant ID input
                  let variantInput = cartForm.querySelector('input[name="id"]');
                  if (!variantInput) {
                    variantInput = document.createElement("input");
                    variantInput.type = "hidden";
                    variantInput.name = "id";
                    cartForm.appendChild(variantInput);
                  }
                  variantInput.value = variantId;

                  // Update the submit button
                  const submitButton = cartForm.querySelector(
                    'button[type="submit"]'
                  );
                  if (submitButton) {
                    submitButton.setAttribute("data-product-url", productUrl);
                    submitButton.setAttribute("data-variant-id", variantId);
                  }
                }

                // Update quick order list if it exists
                const quickOrderList =
                  bulkModalElement.querySelector("quick-order-list");
                if (quickOrderList) {
                  quickOrderList.setAttribute("data-url", productUrl);
                  quickOrderList.setAttribute(
                    "data-product-id",
                    currentProductId
                  );
                  quickOrderList.setAttribute("data-variant-id", variantId);

                  // Force quick order list to reinitialize
                  quickOrderList.removeAttribute("initialized");
                  if (
                    typeof customElements.get("quick-order-list")?.prototype
                      ?.connectedCallback === "function"
                  ) {
                    quickOrderList.connectedCallback();
                  }

                  // Update variant options if they exist
                  const variantOptions =
                    quickOrderList.querySelector(".variant-options");
                  if (variantOptions) {
                    const variantRadios = variantOptions.querySelectorAll(
                      'input[type="radio"]'
                    );
                    variantRadios.forEach((radio) => {
                      if (radio.value === variantId) {
                        radio.checked = true;
                        radio.dispatchEvent(
                          new Event("change", { bubbles: true })
                        );
                      }
                    });
                  }

                  // Update quantity inputs
                  const quantityInputs =
                    quickOrderList.querySelectorAll("quantity-input");
                  quantityInputs.forEach((input) => {
                    if (input) {
                      input.setAttribute("data-variant-id", variantId);
                      const numberInput = input.querySelector(
                        'input[type="number"]'
                      );
                      if (numberInput) {
                        numberInput.setAttribute("data-variant-id", variantId);
                      }
                    }
                  });
                }

                // Force bulk modal to reinitialize
                bulkModalElement.removeAttribute("initialized");
                if (
                  typeof customElements.get("bulk-modal")?.prototype
                    ?.connectedCallback === "function"
                ) {
                  bulkModalElement.connectedCallback();
                }
              }

              // Update variant selectors if they exist
              const variantSelectors = modalContent.querySelectorAll(
                'select[name="id"], input[name="id"]'
              );
              variantSelectors.forEach((selector) => {
                if (selector) {
                  if (selector.tagName === "SELECT") {
                    selector.value = variantId;
                    selector.dispatchEvent(
                      new Event("change", { bubbles: true })
                    );
                  } else {
                    selector.checked = selector.value === variantId;
                    if (selector.checked) {
                      selector.dispatchEvent(
                        new Event("change", { bubbles: true })
                      );
                    }
                  }
                }
              });

              // Only show the modal if it was already open
              if (modalDialog.hasAttribute("open")) {
                setTimeout(() => {
                  modalDialog.show(modalButton);

                  // Additional timeout to ensure components are initialized
                  setTimeout(() => {
                    // Dispatch a custom event to notify components of the update
                    modalDialog.dispatchEvent(
                      new CustomEvent("bulk-modal-updated", {
                        detail: {
                          productUrl,
                          variantId,
                          productId: currentProductId,
                        },
                        bubbles: true,
                      })
                    );
                  }, 100);
                }, 100);
              }
            } else {
              // Only show if already open
              if (modalDialog.hasAttribute("open")) {
                modalDialog.show(modalButton);
              }
            }
          } else {
          }
        } else {
        }
      } else {
      }

      setTimeout(() => {
        // Update price elements
        const comparePriceElement = cardWrapper.querySelector(".strikethrough");
        const salePriceElement = cardWrapper.querySelector(".money");

        // Only update compare price if element exists
        if (comparePriceElement) {
          if (comparePrice == null || comparePrice == 0) {
            comparePriceElement.textContent = "";
            comparePriceElement.classList.add("hidden");
          } else {
            comparePriceElement.classList.remove("hidden");
            comparePriceElement.textContent = `$${(comparePrice / 100).toFixed(
              2
            )}`;
          }
        }

        // Only update sale price if element exists
        if (salePriceElement) {
          salePriceElement.textContent = `$${(price / 100).toFixed(2)}`;
        }

        // Update the product title and URL
        const headingElement = cardWrapper.querySelector(".card__title a");
        if (headingElement) {
          headingElement.textContent = title;
          headingElement.href = productUrl;
        }

        const mediaLink = cardWrapper.querySelector(".media-link");
        if (mediaLink) {
          mediaLink.href = productUrl;
        }

        // Update the badge content if the element and badge value exist
        const badgeElement = cardWrapper.querySelector(".card__badge span");
        if (badgeElement) {
          badgeElement.textContent = badgeValue;
          if (badgeValue === "") {
            badgeElement.classList.add("hidden");
          } else {
            badgeElement.classList.remove("hidden");
          }
        }

        // Update the label content if the element and label value exist
        const labelElement = cardWrapper.querySelector(".bottom-label-text");
        if (labelElement) {
          labelElement.textContent = label;
          if (label === "") {
            labelElement.classList.add("hidden");
          } else {
            labelElement.classList.remove("hidden");
          }
        }

        // Update the Add to Wishlist button
        const addToWishlistButton = cardWrapper.querySelector(
          ".swym-button.swym-add-to-wishlist-view-product"
        );
        if (addToWishlistButton) {
          addToWishlistButton.setAttribute("data-product-id", productId);
          addToWishlistButton.setAttribute("data-variant-id", variantId);

          const wishlistUrl = `/products/${handle}?variant=${variantId}`;
          addToWishlistButton.setAttribute("href", wishlistUrl);

          const currentClass = [...addToWishlistButton.classList].find(
            (className) => className.startsWith("product_")
          );
          if (currentClass) {
            addToWishlistButton.classList.remove(currentClass);
          }
          addToWishlistButton.classList.add(`product_${productId}`);
        }

        // Reinitialize quick add functionality
        if (typeof initQuickAdd === "function") {
          initQuickAdd();
        }
      }, 50); // 50ms delay to allow images to load first
    })
    .catch((error) => {
      console.error("Error fetching product data:", error);
    });
};

document.addEventListener("DOMContentLoaded", function () {
  // Initialize swatches on page load
  const swatches = document.querySelectorAll(".card-swatch:not(.initialized)");
  swatches.forEach((swatch) => {
    swatch.classList.add("initialized");
    swatch.addEventListener("click", function (event) {
      event.preventDefault();

      const cardWrapper = swatch.closest(".product-card-wrapper");
      const cardSwatches = cardWrapper.querySelectorAll(".swatch-container");
      cardSwatches.forEach((sw) => sw.classList.remove("active-swatch"));
      swatch.closest(".swatch-container").classList.add("active-swatch");

      const productUrl = swatch.getAttribute("data-url");
      const handle = productUrl.split("/products/")[1];
      const productId = swatch.getAttribute("data-id");
      const variantId = swatch.getAttribute("data-variant-id");
      const badgeValue = swatch.getAttribute("data-badge");
      const label = swatch.getAttribute("data-label");

      window.fetchProductData(
        handle,
        cardWrapper,
        badgeValue,
        productId,
        variantId,
        label
      );
    });
  });
});
